import Styled from 'styled-components'
import {IoIosInformationCircle} from 'react-icons/io'
import {FaMapMarkerAlt} from 'react-icons/fa'

export const Container = Styled.div`
padding-top: 125px;
margin: 5%;
`

export const Resume = Styled.div`
color: ${props => props.theme.primary};
font-weight: 700;
font-size: 16px;
margin-bottom: 0;
`

export const Details = Styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    color: ${props => props.theme.primary};
    font-weight: 700;
    font-size: 16px;
    gap: 10px;
    margin-top: 1rem;
    border-bottom: 1px solid rgba(5, 9, 34, 0.16);
    line-height: 4rem;
`

export const Text = Styled.div`
color: ${props => props.theme.primary};
font-weight: 500;
font-size: 16px;
line-height: 4rem;
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px solid rgba(5, 9, 34, 0.16);

p {
    margin: 0;
}

p:nth-child(1) {
    //width: 110px;
    //min-width: 110px;
    width: 35%;
}

p:nth-child(2) {
    color: ${props => props.theme.primary};
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    text-transform: capitalize;
    width: 65%;
     
    span:after {
        content: ' | ';
    }
    
    span:last-child:after {
        content: '';
    }
}
`

export const Maps = Styled(FaMapMarkerAlt)`
margin-right: 10px;
width: 20px;
height: 20px;
`

export const DateInformations = Styled.div`
color:${props => props.theme.primary};
font-weight: 500;
font-size: 16px;
display: flex;
gap: 20px;

span{
color: rgba(38, 50, 56, 0.5);
font-weight: 400;
font-size: 14px;
}
`

export const DivContentInput = Styled.form`
margin-top: 30px;

label {
    color: ${props => props.theme.primary};
    font-weight: 400;
    font-size: 17px;
}


.encurtar-border{
    width: 60%;
}
`

export const DivCel = Styled.div`
display: flex;
`

export const SelectDDD = Styled.select`
margin-left: 15px;
border-style: none;
background-color: white;
border-bottom: 1px solid #707070;
color: rgba(71, 70, 70, 0.5);
:focus, :focus {
box-shadow: 0 0 0 0;
outline: 0;
}
`

export const Options = Styled.option`
 color: rgba(71, 70, 70, 0.5);
`

export const CheckboxContainer = Styled.div`
margin-top: 25px;
display: flex;
align-items: center;

label{
padding-left: 10px;
cursor: pointer;
line-height: 20px;
&:active{
    color: #9DA1A6;
}
}

`

export const Radio = Styled.input`
cursor: pointer;
appearance: none;
border: 1px solid  ${props => props.theme.primary};
width: 16px;
height: 16px;
border-radius: 50%;
position: relative;
display:flex;
align-items: center;
justify-content: center;

&:before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background: #050922; 
    border-radius: 50%;
    opacity: 0;
}
&:checked:before {
    opacity: 1;
}
`

export const InfromationIcon = Styled(IoIosInformationCircle)`
margin-right: 5px;
height: 25px;
width: 25px;
color: #050922;

`

export const TitleParagraph = Styled.p`
padding-top: 38px;
color: #636779;
font-weight: 400;
font-size: 12px;
`

export const DivAlign = Styled.div`
display: flex;
`


export const TextRegulation = Styled.div`
color: #050922;
font-size: 12px;
`

export const CheckboxDiv = Styled.div`
margin-top: 30px;
display: flex;
`
export const LabelCheckbox = Styled.label`
color:#050922;
font-size: 14px;
font-weight: 400;
display: flex;
cursor: pointer;

.paragraph{
    color: #000000;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    margin-top: 3px;
}

.css-dk24d0-MuiButtonBase-root-MuiCheckbox-root{
    padding:0;
    color: black;
    margin-right: 4px;
}
`

export const Resumo = Styled.div`
background-color: #F0F0F0;
padding: 20px;
margin-top: 20px;

.title-resume{
    color: #050922;
    font-weight: 400;
    font-size: 18px;
    font-weight: bold;
}

.title{
    color: #050922;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 0;
   
}
.value{
    color: #696969;
    font-size: 13px;
}

.points{
    color: #050922;
    font-weight: 400;
    font-size: 15px;   

}

.valor-total{
    color: #050922;
    font-weight: 400;
    font-size: 17px;
    margin-top: 30px;
    
}
`

export const Cupom = Styled.div`
background-color: #F0F0F0;
margin-top: 30px;
display: flex;
padding: 10px;
margin-bottom: 30px;

input{
    border: 0;
    background-color: #F0F0F0;
    border-bottom: 1px solid #C6C6C5;
    float: right;
    outline: none;
    width: 40%;
    margin-left: 20px;
}

label{
    color: #050922;
    font-size: 17px;
    font-weight: 700;
}
`

export const Points = Styled.div`
display: flex;
flex-direction: row;
align-items: center;
margin-top: 6px;
margin-bottom: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}
`;

export const Values = Styled.div`

display: flex;
flex-direction: row;
align-items: center;
padding-top: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}

`;

export const Line = Styled.div`
border: 1px solid #C6C6C5;
margin-top: 25px;

`
export const Title = Styled.div`
    color: #050922;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 0; 
`;

export const ValuePoints = Styled.div`
    color: #696969;
    font-size: 13px;
`;
